import React from 'react'
import { Link } from 'react-router-dom';
import Blog_1 from '../../../assets/images/services/service-four-btn.svg';


const Blog = () => {
    return (
        <>
            <div className="blog-section-four">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 m-auto">
                            <div className="heading-box text-center">
                                <span
                                    className="sub-title animate fadeInUp wow"
                                    data-wow-duration="1500ms"
                                >
                                    Our Articles
                                </span>
                                <h2
                                    className="heading-title animate fadeInUp wow"
                                    data-wow-duration="1500ms"
                                    data-wow-delay="200ms"
                                >
                                    Read &amp; gather knowledge from our latest News
                                </h2>
                            </div>
                        </div>
                    </div>
                    <div className="row gutter-y-30">
                        <div className="col-lg-4">
                            <div className="blog-box-four">
                                <div className="blog-date-four">
                                    <Link href="/BlogDetails">
                                        <span>06</span>
                                        <span>Nov</span>
                                    </Link>
                                </div>
                                <ul className="blog-four-tag">
                                    <li>
                                        <Link href="/BlogDetails">Business</Link>
                                    </li>
                                    <li>
                                        <span>|</span>
                                    </li>
                                    <li>
                                        <Link href="/BlogDetails">Investment</Link>
                                    </li>
                                </ul>
                                <h4>
                                    <Link href="/BlogDetails">
                                        5 Impactful Elements That Promote IT and Business
                                    </Link>
                                </h4>
                                <Link href="/BlogDetails" className="blog-four-btn">
                                    <img src={Blog_1} alt="icon" />
                                </Link>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="blog-box-four">
                                <div className="blog-date-four">
                                    <Link href="/BlogDetails">
                                        <span>05</span>
                                        <span>Nov</span>
                                    </Link>
                                </div>
                                <ul className="blog-four-tag">
                                    <li>
                                        <Link href="/BlogDetails">Business</Link>
                                    </li>
                                    <li>
                                        <span>|</span>
                                    </li>
                                    <li>
                                        <Link href="/BlogDetails">Finance</Link>
                                    </li>
                                </ul>
                                <h4>
                                    <Link href="/BlogDetails">
                                        Revolutionizing the Future of Financial Services
                                    </Link>
                                </h4>
                                <Link href="/BlogDetails" className="blog-four-btn" >
                                    <img src={Blog_1} alt="icon" />
                                </Link>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="blog-box-four">
                                <div className="blog-date-four">
                                    <Link href="/BlogDetails">
                                        <span>28</span>
                                        <span>Nov</span>
                                    </Link>
                                </div>
                                <ul className="blog-four-tag">
                                    <li>
                                        <Link href="/BlogDetails">Business</Link>
                                    </li>
                                    <li>
                                        <span>|</span>
                                    </li>
                                    <li>
                                        <Link href="/BlogDetails">Research</Link>
                                    </li>
                                </ul>
                                <h4>
                                    <Link href="/BlogDetails">
                                        A Guide to Embracing Meaningful Change in Banking
                                    </Link>
                                </h4>
                                <Link href="/BlogDetails" className="blog-four-btn" >
                                    <img src={Blog_1} alt="icon" />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Blog
